// Navbar.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

const NewNavbar = () => {
  const [Navbar1, setNavbar1] = useState("");
  const [Navbar2, setNavbar2] = useState("");
  const [Navbar3, setNavbar3] = useState("");
  const [Navbar4, setNavbar4] = useState("");
  const [Navbar5, setNavbar5] = useState("");
  const [Navbar51, setNavbar51] = useState("");
  const [Navbar52, setNavbar52] = useState("");
  const [Navbar53, setNavbar53] = useState("");
  const [Phone, setPhone] = useState("");
  const [ProfessionalLink, setProfessionalLink] = useState("");
  const [EmailLink, setEmailLink] = useState("");


  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => {
        // console.log(data.HomeH1);
        setNavbar1(data.Navbar1);
        setNavbar2(data.Navbar2);
        setNavbar3(data.Navbar3);
        setNavbar4(data.Navbar4);
        setNavbar5(data.Navbar5);
        setNavbar51(data.Navbar51);
        setNavbar52(data.Navbar52);
        setNavbar53(data.Navbar53);
        setPhone(data.Phone);
        setProfessionalLink(data.ProfessionalLink);
        setEmailLink(data.EmailLink);
      })
      .catch(error => console.error('Error loading config:', error));
  }, []);

  return (
    <Navbar expand="lg" className="bg-custom" data-bs-theme="light">
      <Container style={{
        // "padding-left": "10px",
        // "padding-right": "10px",
        // margin:0
      }}>
        <Navbar.Brand><Link to="/">{Navbar1}</Link></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {/* <Nav.Link href='/'>Home</Nav.Link>
            <Nav.Link href='/contact'>Contact</Nav.Link>
            <Nav.Link href='/service'>Services</Nav.Link>
            <Nav.Link href='/employees'>Our Barbers</Nav.Link> */}
            <Nav.Link className="mx-3"><Link to="/contact">{Navbar2}</Link></Nav.Link>
            <Nav.Link className="mx-3"><Link to="/service">{Navbar3}</Link></Nav.Link>
            <Nav.Link className="mx-3"><Link to="/employees">{Navbar4}</Link></Nav.Link>

          </Nav>
          <Nav className="ms-auto"> {/* 将 Appointment 下拉菜单放入新的 Nav 组件 */}
            <NavDropdown title={Navbar5} id="basic-nav-dropdown">
              <NavDropdown.Item href={ProfessionalLink}>{Navbar51}</NavDropdown.Item>
              <NavDropdown.Item href={`tel:+1${Phone}`}>{Navbar52}</NavDropdown.Item>
              <NavDropdown.Item href={EmailLink}>{Navbar53}</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NewNavbar;